module.exports = __webpack_public_path__ + "img/schaudt_wa121525.f3766d71.png";